exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#connector-page{margin-top:3.5rem;padding-top:3rem}#connector-page .search-connector-styles{display:block}#connector-page .search-connector-styles .section{padding:1rem 0}#connector-page .search-connector-styles h1.title{font-size:2.5rem!important}#connector-page .search-connector-styles h1.subtitle{font-size:2rem!important}", ""]);

// exports
